import authService from '@/modules/auth/services/auth.service'
import { createRouter, createWebHistory } from 'vue-router'
import { errorsPage } from '@/modules/errors/route'
import { showToast as toast } from '@/helpers/UseToasts'
import { storeApp } from '@/store'
import { http } from '@/http'

// rotas
import { employeesRoute } from '@/modules/employees/routes'
import { profileRoute } from '@/modules/profile/routes'
import { companyRoute } from '@/modules/company/routes'
import { loginRoute } from '@/modules/auth/routes'
import { homeRoute } from '@/modules/home/routes'
import { collabRoutes } from '@/modules/collaborators/routes'
import { permissionsRoute } from '@/modules/auth/lookups'
import { pontoRoute } from '@/modules/ponto/routes'
import { asosRoute } from '@/modules/asos/routes'
import { afastRoute } from '@/modules/afastamento/routes'

const routes = [
  ...loginRoute,
  ...homeRoute,
  ...employeesRoute,
  ...profileRoute,
  ...collabRoutes,
  ...companyRoute,
  ...errorsPage,
  ...pontoRoute,
  ...asosRoute,
  ...afastRoute
]

const router = createRouter({
  history: createWebHistory('#'),
  routes
})

router.beforeEach(async (to, from, next) => {
  storeApp.state.loading = true

  if (to.name === 'logout') {
    return authService.logout()
      .then((res) => {
        localStorage.clear();

        storeApp.dispatch('cleanLocalStorageDataUser')
        storeApp.dispatch('hiddenMenuUserLoggedOut')
        storeApp.dispatch('setUserAuthenticated', false)

        toast(
          'Até logo!',
          'Deslogado com sucesso',
          'success'
        )

        next({ name: 'login' })
      })
      .catch((err) => {
        toast(
          'Aviso',
          'Sessão encerrada',
          'error'
        )

        localStorage.clear()
        next({ name: 'login' })
      })
  }

  if (to.meta.key) {
    const userPermissions = localStorage.getItem('__permissions')

    if (userPermissions) {
      const permissionsArray = userPermissions.split(',')

      // Se meta.key for uma string, verifica se a permissão está no localStorage
      if (typeof to.meta.key === 'string') {
        if (!permissionsArray.includes(to.meta.key)) {
          if (from.name !== 'login') {
            toast(
              'Aviso:',
              'Você não tem permissão para acessar essa página',
              'info'
            )
          }

          const matchedRoute = permissionsRoute.find(item => permissionsArray.includes(item.permission))
          if (matchedRoute) {
            next({ name: matchedRoute.routeName })
          } else {
            console.warn('Nenhuma rota disponível para as permissões do usuário.')
            router.push('/error')
          }
        }
      }

      // Se meta.key for um array, verifica se pelo menos uma permissão está no localStorage
      if (Array.isArray(to.meta.key)) {
        const hasPermission = to.meta.key.some(key => permissionsArray.includes(key))

        if (!hasPermission) {
          if (from.name !== 'login') {
            toast.showToast(
              'Aviso:',
              'Você não tem permissão para acessar essa página',
              'info'
            )
          }

          const matchedRoute = permissionsRoute.find(item => permissionsArray.includes(item.permission))
          if (matchedRoute) {
            next({ name: matchedRoute.routeName })
          } else {
            console.warn('Nenhuma rota disponível para as permissões do usuário.')
            router.push('/error')
          }
        }
      }
    }
  }

  if (to.name !== 'login') {
    try {
      if (from.name !== 'login' || from.name !== 'logout') { 
        await http.get(process.env.VUE_APP_API_URL.concat('auth/me')) 
      }

      storeApp.state.loading = false

      next()
    } catch (error) {
      toast(
        'Aviso',
        'Sua sessão expirou',
        'error'
      )

      localStorage.clear()
      storeApp.dispatch('hiddenMenuUserLoggedOut')
      storeApp.dispatch('setUserAuthenticated', false)
      storeApp.state.loading = false

      next({ name: 'login' })
    }
  } else {
    storeApp.dispatch('setUserAuthenticated', false)
    storeApp.state.accessToken.clear()
    storeApp.state.loading = false
    next()
  }
})

export default router
